export const isElementClicked = (event, selector) => {
  const childEl = event.currentTarget.querySelector(selector);

  return childEl && childEl.contains(event.target);
};
